import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Edit, Copy, DownloadCloud, Share2 } from "lucide-react";
import { Button } from "@shared/ui/button";

interface SopHeaderProps {
  sopDetails: any;
  onNavigateBack: () => void;
}

const SopHeader: React.FC<SopHeaderProps> = ({
  sopDetails,
  onNavigateBack,
}) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(
      `/service-orders/wx-master/create-sop?mode=edit&id=${sopDetails.id}`
    );
  };

  const handleClone = () => {
    // Clone logic here
  };

  const handleExport = () => {
    // Export logic here
  };

  const handleShare = () => {
    // Share logic here
  };

  return (
    <div className="flex items-center gap-4">
      <Button variant="outline" size="sm" onClick={onNavigateBack}>
        <ArrowLeft className="mr-1 h-4 w-4" />
        Back
      </Button>

      <div>
        <h1 className="text-2xl font-bold tracking-tight">{sopDetails.name}</h1>
        <p className="text-muted-foreground">{sopDetails.description}</p>
      </div>

      {/* <div className="ml-auto space-x-2">
        <Button variant="outline" size="sm" onClick={handleEdit}>
          <Edit className="mr-2 h-4 w-4" />
          Edit
        </Button>
      </div> */}
    </div>
  );
};

export default SopHeader;
